import { render, staticRenderFns } from "./imgSolution.vue?vue&type=template&id=6c744857&scoped=true&lang=html&"
import script from "./imgSolution.vue?vue&type=script&lang=js&"
export * from "./imgSolution.vue?vue&type=script&lang=js&"
import style0 from "./imgSolution.vue?vue&type=style&index=0&id=6c744857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c744857",
  null
  
)

export default component.exports